import { type TimestampModel } from '../../../types';
import { SearchContext } from '../types';
import { Timestamp } from '../../../services/Timestamp';
import { isLive, isToday, isYesterday } from '../../../utils/timestamp-utils';
import { translate } from '../../../constants/translation';

export const containsPhrase = <T>(phrase: string, item: T, selector: (i: T) => string): boolean => {
  return !!selector(item) && selector(item).toLowerCase().includes(phrase.toLowerCase());
};

export const canChangeContextToGlobal = (context: SearchContext): boolean => {
  return context !== SearchContext.Global;
};

export const buildSearchFilter = (searchPhrase: string, operation: string = null, mmsi: string = null): string => {
  const queryStringParams = new URLSearchParams();

  if (searchPhrase) {
    queryStringParams.append('SearchPhrase', searchPhrase);
  }

  if (operation) {
    queryStringParams.append('Operation', operation);
  }

  if (mmsi) {
    queryStringParams.append('Mmsi', mmsi);
  }

  const queryString = queryStringParams.toString();
  return queryString ?? '';
};

export const formatDateTime = (timestamp: TimestampModel, timezone: string): string => {
  const ts = Timestamp.fromMilliseconds(timestamp.valueInMilliseconds);

  if (isLive(ts)) {
    return translate('LIVE');
  }

  if (isToday(ts, timezone)) {
    return translate('TODAY');
  }

  if (isYesterday(ts, timezone)) {
    return translate('YESTERDAY');
  }

  return ts.toLocationDateTimeOffset(timezone).format('DD MMM YYYY');
};
